import { makeStyles } from "@material-ui/core"

export const useStyles = makeStyles(() => ({
  container: {
    '& .MuiDialog-paperWidthSm': {
      maxWidth: '1400px',
    },
    '& .MuiTableCell-root': {
      textTransform: 'uppercase'
    }
  },
  simpleContainer: {
    width: '400px',
    display: 'flex',
    alignItems: 'center',
    margin: '0 auto'
  },
  tableContainer: {
    '& .MuiTableHead-root': {
      paddingTop: '12px',
      background: 'rgb(246, 246, 246)',
      position: 'relative',
    },
    '& .MuiTableCell-head': {
      fontWeight: 'bold',
      padding: '20px 40px 10px 40px'
    },
    '& .MuiTableCell-root': {
      textAlign: 'center'
    }
  },
  btnClose: {
    width: '10px',
    height: '32px',
    padding: '0px',
    position: 'absolute',
    right: '0',
    top: 0,
    fontSize: '20px'
  },
  dialogContent: {
    textAlign: 'center',
    fontSize: '16px',
    padding: '20px'
  }
}))